import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const FormatQuote = props => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <path d="M23.143 11c0.558 0 0.857 0.48 0.857 1v2.715c0 4.345-1.72 6.285-5.143 6.285-0.504 0-0.857-0.4-0.857-1v-0.802c0-0.355 0.334-0.643 0.64-0.643 1.038 0 1.547-0.805 1.547-1.602 0-0.42-0.107-0.81-0.34-1.096-0.266-0.326-0.738-0.5-1.22-0.5-0.304 0-0.627-0.287-0.627-0.642v-2.715c0-0.584 0.383-1 0.857-1h4.285zM13.143 11c0.558 0 0.857 0.48 0.857 1v2.715c0 4.345-1.72 6.285-5.143 6.285-0.504 0-0.857-0.4-0.857-1v-0.802c0-0.355 0.334-0.643 0.64-0.643 1.038 0 1.547-0.805 1.547-1.602 0-0.42-0.107-0.81-0.34-1.096-0.266-0.326-0.738-0.5-1.22-0.5-0.304 0-0.627-0.287-0.627-0.642v-2.715c0-0.584 0.383-1 0.857-1h4.285z" />
  </SvgIcon>
);

export default FormatQuote;
